$(document).ready(function() {
    $('.filter-toggle-column').click(function(){
        $('.filter-drawer-main').toggleClass('active');
        $('html').toggleClass('overflow-hidden');
    })
    $('.filter-close').click(function(){
        $('.filter-drawer-main').removeClass('active');
        $('html').removeClass('overflow-hidden');
    })
    
    
    $('.filter-item-main>.filter-item-btn').click(function(){
        $(this).closest('.filter-item-main').find('.filter-child-main').slideToggle();
    })
})